<template>
  <div id="cover" class="page-cover-overlay" :class="{ 'is-opened': isOpen }" :style="bgStyle">
    <div class="right-content">
      <div class="photo-frame-oval">
        <img :src="couplePhotoUrl" alt="Foto Pasangan" @error="$event.target.src='/img/cover1.jpeg'">
      </div>
      <h2 class="couple-name-serif">{{ coupleNameDisplay }}</h2>
      <div class="guest-info">
        <p>Kepada Yth,</p>
        <p class="guest-name">{{ guestDisplay }}</p>
      </div>
      <button class="btn-open" @click="$emit('open')">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" />
          <rect x="3" y="5" width="18" height="14" rx="2" />
        </svg>
        OPEN INVITATION
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';

export default {
  name: 'CoverSection',
  props: {
    isOpen: { type: Boolean, default: false },
    guestName: { type: String, default: '' },
  },
  emits: ['open'],
  computed: {
    ...mapState(useInvitationStore, ['client']),
    bgStyle() {
      return { backgroundImage: `url('/img/cover1.jpeg')`, backgroundSize: 'cover', backgroundPosition: 'center' };
    },
    couplePhotoUrl() {
      if (this.client.foto_couple) {
        return `https://admin.itsyourdayofficial.com/foto_cover/${this.client.foto_couple}`;
      }
      if (this.client.foto_cover) {
        return `https://admin.itsyourdayofficial.com/foto_cover/${this.client.foto_cover}`;
      }
      return '/img/cover1.jpeg';
    },
    coupleNameDisplay() {
      const p = this.client.nama_pria || 'Pria';
      const w = this.client.nama_wanita || 'Wanita';
      const str = this.client.hajat === 'wanita' ? `${w} & ${p}` : `${p} & ${w}`;
      return str.toUpperCase();
    },
    guestDisplay() {
      return this.guestName || 'Tamu Undangan';
    },
  },
};
</script>

<style scoped>
.page-cover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 1s cubic-bezier(0.77, 0, 0.175, 1), opacity 1s ease;
}
.page-cover-overlay.is-opened {
  transform: translateY(-100%);
  opacity: 0;
  pointer-events: none;
}
.right-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 2;
}
.photo-frame-oval {
  width: 190px;
  height: 280px;
  border-radius: 120px;
  overflow: hidden;
  margin-bottom: 2rem;
  border: 2px solid #5E6E85;
  box-shadow: 0 10px 25px rgba(70, 91, 115, 0.25);
  position: relative;
  z-index: 2;
}
.photo-frame-oval img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.couple-name-serif {
  font-family: 'Cinzel', serif;
  font-size: 2.2rem;
  font-weight: 600;
  letter-spacing: 3px;
  margin-bottom: 2.5rem;
  color: #1A2841;
  text-shadow: 0 0 10px rgba(255,255,255,0.9), 0 0 20px rgba(255,255,255,1);
}
.guest-info {
  margin-bottom: 2.5rem;
  z-index: 2;
  background: rgba(255,255,255,0.4);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  padding: 1.2rem 5rem;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.6);
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  text-align: center;
}
.guest-info p {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: #1A2841;
  font-weight: 600;
  text-shadow: 0 0 8px rgba(255,255,255,0.9), 0 0 15px rgba(255,255,255,1);
}
.guest-info .guest-name {
  font-weight: 700;
  font-size: 1.4rem;
  border-bottom: 2px solid #1A2841;
  padding-bottom: 4px;
  display: inline-block;
  box-shadow: 0 5px 5px -5px rgba(255, 255, 255, 0.8);
}
.btn-open {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: rgba(94,110,133,0.85);
  color: white;
  border: 1px solid rgba(255,255,255,0.5);
  padding: 14px 34px;
  border-radius: 50px;
  font-family: 'Cinzel', serif;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 1.5px;
  cursor: pointer;
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
  z-index: 2;
}
.btn-open:hover {
  background-color: rgba(94,110,133,1);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

/* Responsiveness for mobile screens to prevent overflow */
@media (max-width: 480px), (max-height: 800px) {
  .photo-frame-oval {
    width: 150px;
    height: 220px;
    margin-bottom: 1.5rem;
  }
  .couple-name-serif {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
  }
  .guest-info {
    padding: 1rem 3rem;
    margin-bottom: 1.5rem;
  }
  .guest-info p {
    font-size: 1.1rem;
  }
  .guest-info .guest-name {
    font-size: 1.25rem;
  }
  .btn-open {
    padding: 12px 28px;
    font-size: 0.85rem;
  }
}
</style>
